import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-clear-cache-page',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div style="padding: 20px; max-width: 600px; margin: 50px auto; font-family: Arial, sans-serif;">
      <h1>🧹 Nettoyage du cache PWA</h1>
      <div style="background: #d1ecf1; padding: 15px; border-radius: 4px; margin-bottom: 20px;">
        <strong>Utilisez cet outil si votre application se charge à l'infini.</strong>
      </div>
      
      <button 
        (click)="clearAll()" 
        style="background: #dc3545; color: white; border: none; padding: 12px 24px; border-radius: 4px; cursor: pointer; font-size: 16px;">
        ⚠️ Tout nettoyer et recharger
      </button>
      
      <div *ngIf="message" [style]="messageStyle" style="margin-top: 20px; padding: 15px; border-radius: 4px;">
        {{ message }}
      </div>
    </div>
  `
})
export class ClearCachePageComponent implements OnInit {
  message = '';
  messageStyle = '';

  ngOnInit(): void {
    // Reset les compteurs de rechargement pour éviter les boucles
    sessionStorage.removeItem('reloadCount');
    sessionStorage.removeItem('lastReloadTime');
  }

  async clearAll(): Promise<void> {
    try {
      this.message = 'Nettoyage en cours...';
      this.messageStyle = 'background: #d1ecf1; color: #0c5460;';

      // 1. Désinscrire les service workers
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (let registration of registrations) {
          await registration.unregister();
        }
      }

      // 2. Vider le cache
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
      }

      // 3. Vider le localStorage
      localStorage.clear();

      // 4. Vider IndexedDB
      if ('indexedDB' in window) {
        const databases = await indexedDB.databases();
        for (const db of databases) {
          if (db.name) {
            indexedDB.deleteDatabase(db.name);

          }
        }
      }

      this.message = '✅ Tout nettoyé! Rechargement de la page...';
      this.messageStyle = 'background: #d4edda; color: #155724;';

      setTimeout(() => {
        window.location.href = '/';
      }, 1000);
    } catch (error: any) {
      this.message = '❌ Erreur: ' + (error.message || error);
      this.messageStyle = 'background: #f8d7da; color: #721c24;';
      console.error('Erreur lors du nettoyage:', error);
    }
  }
}

